<template>
    <InfoListComponent />
</template>


<script>
import InfoListComponent from '../../components/study_plan/info_list_component.vue'

export default {
    data() {
        return {

        }
    },
    methods : {
    },
    components: {
        InfoListComponent
    }
}
</script>